import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { useDateDefinition, today } from '@gov-nx/utils/common';

interface UseDateRangeFormDefinitionProps {
	fields: {
		from: {
			label: string;
			defaultValue?: string;
			isRequired?: boolean;
			isDisabled?: boolean;
		};
		to: {
			label: string;
			defaultValue?: string;
			isRequired?: boolean;
			isDisabled?: boolean;
			noOlderThanErrorMessage?: string;
		};
	};
}

export const useDateRangeFormDefinition = ({
	fields: { from, to },
}: UseDateRangeFormDefinitionProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);

	const datumOd = useDateDefinition({
		name: 'datumOd',
		label: from.label,
		defaultValue: from.defaultValue ? today(from.defaultValue) : undefined,
		isRequired: from.isRequired,
		isDisabled: from.isDisabled,
	});

	const datumDo = useDateDefinition({
		name: 'datumDo',
		label: to.label,
		noOlderThan: {
			fieldName: datumOd.field.field.name,
			errorMessage:
				to.noOlderThanErrorMessage ??
				t('validace.platnost-do.starsi-nez-datum-od'),
		},
		defaultValue: to.defaultValue ? today(to.defaultValue) : undefined,
		isRequired: to.isRequired,
		isDisabled: to.isDisabled,
	});

	return [datumOd, datumDo];
};
